<template lang="pug">
    .page
        .banner
            img(src="@/assets/img/banner_contact.png")
            .title-container
                .title 招聘岗位
                .text RECRUIT
        .content-container
            .job-item(v-for="(item, index) in list" :key="index")
                .name {{item.title}}
                .jobs
                    .addr 工作地点：{{item.city}}
                    .unit 工作单位：{{item.workplace}}
                    .exp 工作经验：{{item.experience}}
                .date
                    .pre 发布时间：{{item.push_at}}
                    .end 截止时间：{{item.deadline}}
                .more(@click="handleGoDetail(item)") MORE+
        .dialog(v-show="showDialog", @click="showDialog = false")
            .dialog-main
                .close
                .dialog-content
                    .content-container
                        .job-item
                            .name {{detail.title}}
                            .jobs
                                .addr 工作地点：{{detail.city}}
                                .unit 工作单位：{{detail.workplace}}
                                .exp 工作经验：{{detail.experience}}
                            .date
                                .pre 发布时间：{{detail.push_at}}
                                .end 截止时间：{{detail.deadline}}
</template>

<script>
import axios from 'axios'

export default {
    data() {
        return {
            more: false,
            page: 1,
            limit: 15,
            list: [],
            showDialog: false,
            detail: {}
        }
    },
    methods: {
        onGetDataList() {
            axios.get(`/api/job?page=${this.page}&limit=${this.limit}`).then(res => {
                this.list = res.data.items
                this.more = res.data.num_items_per_page < this.limit
            })
        },
        onGetDataListMore() {
            if (this.more) {
                this.page++
                axios.get(`/api/job?page=${this.page}&limit=${this.limit}`).then(res => {
                    this.list = this.list.concat(res.data.items)
                    this.more = res.data.num_items_per_page < this.limit
                })
            }
        },
        handleGoDetail(_item) {
            this.detail = _item
            this.showDialog = true
        }
    },
    created() {
        this.onGetDataList()
    }
}
</script>

<style lang="sass" scoped>
.page
    width: 100%
    padding-top: 60px
    .dialog-main
        background: #fff
        width: 80%
        box-sizing: border-box
        padding: 2%
        max-height: 60vh
        overflow-y: scroll
        .close
        .dialog-content
            line-height: 1.5
            img
                width: 100%
                display: block
            .info
                .name
                .office
                .content
                    font-size: 12px
    .banner
        width: 100%
        display: flex
        justify-content: center
        align-items: center
        flex-direction: column
        text-align: center
        height: 100px
        position: relative
        img
            height: 100%
            width: 100%
        .title-container
            position: absolute
        .title
            font-size: 22px
        .text
            font-size: 12px
            line-height: 1.8
    .content-container
        max-width: 1000px
        margin: 0 auto
        padding-top: 60px
        .job-item
            display: flex
            flex-direction: column
            width: 100%
            padding: 50px 60px
            box-sizing: border-box
            border-bottom: 1px solid #eee
            justify-content: space-between
            font-size: 14px
            .name
                font-size: 16px
                font-weight: bold
                margin-bottom: 1em
            .more
                cursor: pointer
                margin-top: 1em
                font-size: 16px
@media screen and (min-width: 1024px)
    .page
        width: 100%
        padding-top: 100px
        .dialog
            position: fixed
            height: 100vh
            width: 100%
            left: 0
            top: 0
            background: rgba(0, 0, 0, 0.3)
            display: flex
            align-items: center
            justify-content: center
            .dialog-main
                background: #fff
                width: 900px
                box-sizing: border-box
                padding: 20px
                max-height: unset;
                overflow-y: unset
                .close
                .dialog-content
                    display: flex
                    line-height: 2
                    img
                        width: 400px
                        display: block
                    .info
                        padding: 0 20px
                        box-sizing: border-box
                        max-height: 500px
                        overflow-y: scroll
                        .name
                            font-size: 18px
                        .office
                            font-size: 14px
                        .content
                            font-size: 14px
                            p
                                margin: 35px auto
        .banner
            display: flex
            justify-content: center
            flex-direction: column
            align-items: center
            width: 100%
            height: 325px
            text-align: center
            position: relative
            img
                height: 100%
                width: 100%
                object-fit: cover
                display: block
            .title-container
                position: absolute
            .title
                font-size: 22px
            .text
                font-size: 12px
                line-height: 2
        .content-container
            max-width: 1000px
            margin: 0 auto
            padding-top: 60px
            .job-item
                display: flex
                flex-direction: row
                width: 100%
                padding: 50px 60px
                box-sizing: border-box
                border-bottom: 1px solid #eee
                justify-content: space-between
                font-size: 14px
                .name
                    font-size: 16px
                    font-weight: bold
                    margin-bottom: 0
                .more
                    cursor: pointer
                    font-size: 16px
                    margin-top: 0
</style>